<template>
    <!-- Ce composant ne rend rien visuellement -->
    <div v-show="false"></div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'

export default {
    name: 'MenuActivator',

    props: {
        parentId: {
            type: [String, Number],
            default: null,
            description: 'Categorie principale du menu'
        },
        currentId: {
            type: [String, Number],
            default: null,
            description: 'Sous catégorie'
        },
        isHome: {
            type: Boolean,
            default: false,
            description: 'Homepage ou Quotidien ?'
        }
    },

    setup(props) {
        const parentId = ref(null)
        const currentId = ref(null)

        // Computed pour savoir si on est sur la page parent
        const isOnParentPage = computed(() => {
            return parentId.value && currentId.value && parentId.value === currentId.value
        })

        onMounted(() => {
            // Récupérer les IDs
            parentId.value = getParentId()
            currentId.value = getCurrentId()

            if (props.isHome) {
                activateMainMenu()
            }
            // Activer le menu
            else if (parentId.value && currentId.value) {
                activateMenu()
            }

        })

        // Watcher pour réagir aux changements d'IDs
        watch(() => [parentId.value, currentId.value], () => {
            if (parentId.value && currentId.value) {
                activateMenu()
            }
        })

        const getParentId = () => {
            if (props.parentId) return props.parentId.toString()
            return null
        }

        const getCurrentId = () => {
            if (props.currentId) return props.currentId.toString()
            return null
        }

        const activateMenu = () => {
            activateMainMenu()
            activateSubMenus()
        }

        const activateMainMenu = () => {
            const mainMenuLinks = document.querySelectorAll('#main-menu .swiper-slide a[data-content-id], #main-menu .swiper-slide a[data-home]')

            mainMenuLinks.forEach(link => {
                const linkContentId = link.getAttribute('data-content-id')
                const isHomeLink = link.hasAttribute('data-home')
                const swiperSlide = link.closest('.swiper-slide')

                if ((props.isHome && isHomeLink) || (!props.isHome && linkContentId === parentId.value)) {
                    // Activer le lien approprié
                    link.classList.add('menu-active')
                    if (swiperSlide) swiperSlide.classList.add('slide-active')
                } else {
                    // Désactiver les autres
                    link.classList.remove('menu-active')
                    if (swiperSlide) swiperSlide.classList.remove('slide-active')
                }
            })
        }

        const activateSubMenus = () => {
            // Ne pas activer les sous-menus si on est sur la home
            if (props.isHome) return

            const subMenus = document.querySelectorAll('.submenu[data-parent-content-id]')

            subMenus.forEach(subMenu => {
                const subMenuParentId = subMenu.getAttribute('data-parent-content-id')

                if (subMenuParentId === parentId.value) {
                    // Afficher ce sous-menu
                    subMenu.classList.add('submenu-active')
                    subMenu.style.display = 'block'

                    // Gérer les liens du sous-menu
                    activateSubMenuLinks(subMenu)
                } else {
                    // Cacher les autres sous-menus
                    subMenu.classList.remove('submenu-active')
                    subMenu.style.display = 'none'
                }
            })
        }

        const activateSubMenuLinks = (subMenu) => {
            const subMenuLinks = subMenu.querySelectorAll('a[data-content-id]')

            subMenuLinks.forEach(link => {
                const linkId = link.getAttribute('data-content-id')

                // Si on est sur la page parent, aucun sous-lien actif
                if (isOnParentPage.value) {
                    link.classList.remove('submenu-link-active')
                }
                // Si on est sur une sous-page, activer le lien correspondant
                else if (linkId === currentId.value) {
                    link.classList.add('submenu-link-active')
                } else {
                    link.classList.remove('submenu-link-active')
                }
            })
        }


        const setIds = (newParentId, newCurrentId) => {
            parentId.value = newParentId.toString()
            currentId.value = newCurrentId.toString()
        }

        const refresh = () => {
            parentId.value = getParentId()
            currentId.value = getCurrentId()
        }

        // Exposer les méthodes pour usage externe
        window.menuActivation = {
            setIds,
            refresh
        }

        return {
            parentId,
            currentId,
            isOnParentPage,
            setIds,
            refresh
        }
    }
}
</script>
